import { SoloPostBlockSliceType } from '../../../../../domains/Prismic/BrandPages/BrandPagesDocument';
import { PostBlock } from '../Nested/PostBlock';

import style from './SoloPostBlockSlice.module.css';

export type SoloPostBlockSliceProps = SoloPostBlockSliceType;

export function SoloPostBlockSlice({
    title,
    text,
    picture,
    ctaLabel,
    ctaLink,
    target,
    sliceIndex,
}: SoloPostBlockSliceProps & { sliceIndex?: number }) {
    return (
        <div className={style.wrapper}>
            <PostBlock
                title={title}
                text={text}
                picture={picture}
                ctaLabel={ctaLabel}
                ctaLink={ctaLink}
                target={target}
                sliceIndex={sliceIndex}
            />
        </div>
    );
}
